import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Dialog, DialogTitle, DialogContent, DialogContentText, Grid, Button, DialogActions, colors } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

const useStyles = makeStyles((theme) => ({
  deleteButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.red[900]} 30%, ${colors.red[800]} 90%)`,
    color: 'white',
  },
}))

export const CustomDialog = (props) => {
  const classes = useStyles()
  const { titulo, mensagens, ...rest } = props
  return (
    <Dialog {...rest}>
      <DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
      <DialogContent>
        {mensagens && mensagens.map((mensagem, index) => (
          <DialogContentText key={index}>
            <Grid container spacing={2} alignItems="center">
              <Grid item md={1} sm={1} lg={1} xs={1}>
                <ErrorOutlineIcon />
              </Grid>
              <Grid item md={11} sm={11} lg={11} xs={11}>
                {mensagem}
              </Grid>
            </Grid>
          </DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={rest.onClose} className={classes.deleteButton} autoFocus fullWidth>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
